import React, {
  useCallback,
  useContext,
  useEffect,
  
  useRef,
  
  useState,
} from 'react';
import { useTranslation, getLanguage } from 'react-multi-lang';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import {
  servicesSlice,
  servicesState,
  service,

} from './ServicesSlice';
import { addServiceSlice } from './AddModal/AddModalSlice';

import MyDashbard from '../../components/Table/dashy_board';
// API
import API, { sortDirectionType } from '../../services/api/api';

// Components
import TableActionBar from '../../components/TableActionBar/TableActionBar';

import { EllipsisLoader, WhiteboxLoader } from '../../components/Loader/Loader';
import AddModal from './AddModal/AddModal';
import Showservice from './ShowModal/ShowModal';

import { havePermission } from '../../services/hoc/permissions';
import { Col, Row } from 'react-grid-system';
import { AnimationButton } from '../../components/FormElements/FormElements';
import { editServicePricingSlice } from './EditServicePricing/EditServicePricingSlice';
import EditServciePricing from './EditServicePricing/EditServciePricing';
import { servicePricingSlice } from './ServicePricing/ServicePricingSlice';
import ServicePricing from './ServicePricing/ServicePricing';
import { Tooltip } from '@mui/material';
import { useNotification } from '../../services/usenotification';
import { getListSort } from '../../services/hoc/sort';

import { SortTable } from '../../components/Table/SortTable';
import { RowContainer } from '../../components/Table/row_container';
import { Dispatch } from '@reduxjs/toolkit';
import SettingContext from '../../services/context/setting-contentxt/setting-context';
import DetailDrawer from '../../components/Drawer/Drawer';
import DeleteModalContext from '../../services/context/delete-modal/delete-modal-context';
import { iDeleteModal } from '../../services/context/delete-modal/delete-modal-provider';

import { useAPI } from '../../services/hoc/useAPI';

interface ServiceDetailsProps {
  fetchData: Function;
  remove: Function;
  state: servicesState;
  dispatch: Dispatch;
  t: (par: string) => string;
  ENDPOINTS: API;

  columnWidth: number;
  deleteGlassWork: Function;
  editGlassWork: Function;
  setModal: Function;
}

///////////////////////// Detail Interface /////////////////////

const ServiceDetails = (props: ServiceDetailsProps) => {
  const { setOpenDeleteModal } = useContext(DeleteModalContext);
  const { isPc } = useContext(SettingContext);
  return (
     
    <Col md={props.columnWidth}>
      {props.state.isLoading &&  <WhiteboxLoader />  }
      <div
        style={{
          maxHeight: 'calc(100vh - 130px)',
          overflow: 'auto',
        }}>
        <h1
          className="header"
          style={{
            fontSize: '28px',
            maxWidth: '300px',
            fontWeight: 500,
          }}>
          {props.state.service?.name}
        </h1>
        <div
          style={{
            position: 'absolute',
            top: 10,
            right: getLanguage() === 'ar' ? 'auto' : 35,
            left: getLanguage() === 'ar' ? 35 : 'auto',
          }}>
          <i
            className="icon-close"
            style={{ color: 'tomato', cursor: 'pointer' }}
            onClick={(e) => {
              props.dispatch(
                servicesSlice.actions.setService({
                  service: undefined,
                }),
              );
            }}></i>
        </div>
        <table
          style={{
            borderSpacing: 0,
            borderCollapse: 'separate',
            width: '95%',
          }}>
          <div style={{ borderBottom: '1px solid #D3D3D3' }}>
            <span
              style={{
                color: '#C5C5C5',
              }}>
              {props.t('serial_no')}
            </span>
            <span
              style={{
                textAlign: 'end',
                margin: '0 10px',
              }}>
              {props.state.service?.code}
            </span>
          </div>
          <div style={{ borderBottom: '1px solid #D3D3D3' }}>
            <span
              style={{
                color: '#C5C5C5',
              }}>
              {props.t('Unit')}
            </span>
            <span
              style={{
                margin: '0 5px',
                textAlign: 'end',
              }}>
              {props.state.service?.unit}
            </span>
          </div>
          <div style={{ borderBottom: '1px solid #D3D3D3' }}>
            <span
              style={{
                color: '#C5C5C5',
              }}>
              {props.t('min_area')}
            </span>
            <span
              style={{
                borderBottom: '1px solid #D3D3D3',
                textAlign: 'end',
                margin: '0 5px',
              }}>
              {props.state.service?.min_area}
            </span>
          </div>
        </table>
        <h3 style={{ marginTop: '40px', marginBottom: '5px' }}>
          {props.t('materials')}
        </h3>
        {/* <DashboardTable
                        header={[t("material"), t('code'), t('price')]}
                        body={generateMaterialData()}
                        hasMore={state.hasMore}
                        loadMore={fetchData}
                    /> */}
        <MyDashbard
          data={props.state.glassWorkPrices}
          header={[props.t('material'), props.t('code'), props.t('price')]}
          deleteRow={
            havePermission('Delete Glass') ? props.deleteGlassWork : undefined
          }
          editRow={
            havePermission('Edit Glass') ? props.editGlassWork : undefined
          }
          this_for="glass_work"
          hasMore={props.state.hasMore}
          loadMore={props.fetchData}
          key_header={['name', 'code', 'price']}
        />

        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <AnimationButton
            label={props.t('edit_service')}
            disabled={!havePermission('Edit Glass Work')}
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              e.stopPropagation();
              props.setModal((pre: any) => ({ ...pre, openAddModal: true }));
              props.dispatch(addServiceSlice.actions.setIsOpen(true));
              props.dispatch(
                addServiceSlice.actions.setEditId(props.state.service?.id ?? 0),
              );
              props.dispatch(
                addServiceSlice.actions.set({
                  description: props.state.service?.description,
                  name: props.state.service?.name,
                  code: props.state.service?.code,
                  min_area: props.state.service?.min_area,
                  unit: props.state.service?.unit,
                }),
              );
            }}
          />

          <AnimationButton
            label={props.t('add_material')}
            disabled={!havePermission('Add Glass')}
            onClick={(e: React.MouseEvent<HTMLElement>) => {
              props.setModal((pre: any) => ({
                ...pre,
                openServicePricing: true,
              }));
              props.dispatch(servicePricingSlice.actions.setIsOpen(true));
            }}
          />

          <AnimationButton
            className="danger"
            disabled={!havePermission('Delete Glass Work')}
            label={props.t('delete_service')}
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              e.stopPropagation();
              setOpenDeleteModal((pre: iDeleteModal) => ({
                ...pre,
                open: true,
                message: props.t('delete_confirmation'),
                remove:() =>props.remove(props.state.service?.id),
                drawer_parent:isPc?false: true,
              }));
              // Confirm({
              //   message:  props.t('delete_confirmation'),
              //   onConfirm: () =>  props.remove( props.state.service?.id),
              // });
            }}
          />
        </div>
      </div>
    </Col>
  );
};

///////////////////////// Main Interface /////////////////////

const Services =  () => {
  // Translation
  const t = useTranslation();
  const { isPc } = useContext(SettingContext);
  const { setOpenDeleteModal } = useContext(DeleteModalContext);
  const [openDetailDrawer, setOpenDetailDrawer] = useState(false);
  const {  alertError500 } = useNotification();
  const [pagesInfo, setPagesInfo] = useState({ page: 1, lastPage: 1 });
  const [modal, setModal] = useState({
    openAddModal: false,
    openShowService: false,
    openServicePricing: false,
    openEditServicePricing: false,
  });
 

  // Redux
  const dispatch = useDispatch();
  const state = useSelector(
    (state: { services: servicesState }) => state.services,
  );
  const keyword_ref=useRef<string|null>(null)

  // Hooks

const ENDPOINTS = useAPI()

  // Search
  const search = (value: string) => {
    dispatch(servicesSlice.actions.reset());
    keyword_ref.current=Boolean(value)?value:null
    fetchData(1, Boolean(value) ? 20 : 8, value);
  };

  // Fetch Data
  const fetchData = useCallback((
    page: number,
    page_size: number = 10,
    keyword?: string,
    sort_field?: number,
    sort_direction?: sortDirectionType,
  ) => {
    dispatch(servicesSlice.actions.setIsFetching(true));
    keyword=Boolean(keyword)?keyword:keyword_ref.current?keyword_ref.current:''
    ENDPOINTS.glassWorks()
      .index({ page, page_size, keyword, sort_field, sort_direction })
      .then((response: any) => {
        dispatch(servicesSlice.actions.setIsFetching(false));
        dispatch(servicesSlice.actions.setPage(pagesInfo.page));
        if (response.data.data.last_page)
          setPagesInfo((pre) => ({
            ...pre,
            lastPage: response.data.data.last_page,
          }));
        let services: service[] = response.data.data.glass_works.map(
          (service: any): service => {
            return {
              id: service.id,
              description: service.description,
              name: service.name,
              code: service.code,
              min_area: service.min_area,
              unit: service.unit,
            };
          },
        );

        dispatch(servicesSlice.actions.initializeServices(services));

        dispatch(
          servicesSlice.actions.setHasMore(
            page < Number(response.data.data.last_page),
          ),
        );
        dispatch(servicesSlice.actions.setIsFetching(false));
        if (!state.isLoaded) dispatch(servicesSlice.actions.setIsLoaded(true));
      })
      .catch((err: any) => {
        alertError500(err);
        dispatch(servicesSlice.actions.setIsFetching(false));
      });
  },[dispatch,ENDPOINTS,state.isLoaded,pagesInfo.page,alertError500])


  const fetchSortedData =useCallback( (
    sort_field: number,
    sort_direction: sortDirectionType,
  ) => {
    if (sort_direction && sort_field) {
      fetchData(
        state.page,
        8,
        '',
         sort_field,
         sort_direction,
      );
    }
  },[state.page])

  // Fetch Services
  const showService =useCallback ((id: number) => {
    dispatch(servicesSlice.actions.setIsLoading(true))
    ENDPOINTS.glassWorks()
      .show({ id })
      .then((res: any) => {
        dispatch(servicesSlice.actions.setIsLoading(false))
        dispatch(servicesSlice.actions.setService({ service: res.data.data }));
        dispatch(
          servicesSlice.actions.addGlassWorkPrices(res.data.data.glasses),
        );
      })
      .catch((err: any) =>{ 
        dispatch(servicesSlice.actions.setIsLoading(false))
        alertError500(err)
      });
  },[ENDPOINTS,alertError500,dispatch])

  const deleteGlassWork = (glassWorkPrice: any) => {
    setOpenDeleteModal(
      (pre: iDeleteModal): iDeleteModal => ({
        ...pre,
        open: true,
        drawer_parent: true,
        message: t('delete_confirmation'),
        remove: () => removePrice(glassWorkPrice.pid),
      }),
    );
    // Confirm({
    //   message: t('delete_confirmation'),
    //   onConfirm: () => removePrice(glassWorkPrice.pid),
    // });
  };
  const editGlassWork = (glassWorkPrice: any) => {
    setModal((pre) => ({ ...pre, openEditServicePricing: true }));
    dispatch(editServicePricingSlice.actions.setIsOpen(true));
    dispatch(editServicePricingSlice.actions.setGlassPrice(glassWorkPrice));
    dispatch(
      editServicePricingSlice.actions.set({
        glass_id: glassWorkPrice.gid,
        glass_work_id: glassWorkPrice.gwid,
        id: glassWorkPrice.pid,
        price: `${glassWorkPrice.price}`,
      }),
    );
  };

  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const toggleSelectedId = (id: number) => {
    if (!havePermission('Delete Component')) return;
    let index = selectedIds.findIndex((selectedId) => selectedId === id);
    if (index !== -1) {
      setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
    } else setSelectedIds([...selectedIds, id]);
  };

  // Delete
  const remove = (id?: number) => {
    let ids = id ? [id] : selectedIds.map((x) => +x);
    dispatch(servicesSlice.actions.setIsLoading(true));
    ENDPOINTS.glassWorks()
      .delete({ ids })
      .then(() => {
        setSelectedIds([]);
        dispatch(servicesSlice.actions.setIsLoading(false));
        dispatch(servicesSlice.actions.deleteServices(ids));
        dispatch(
          servicesSlice.actions.setService({
            service: undefined,
          }),
        );
      })
      .catch((err: any) => {
        alertError500(err);
        dispatch(servicesSlice.actions.setIsLoading(false));
      });
  };

  // Delete
  const removePrice = (id?: number) => {
    let ids = id ? [id] : selectedIds.map((x) => +x);
    dispatch(servicesSlice.actions.setIsLoading(true));
    ENDPOINTS.pricing()
      .deletePrices({ ids })
      .then(() => {
        dispatch(servicesSlice.actions.setIsLoading(false));
        dispatch(servicesSlice.actions.deleteGlassWorkPrices(ids[0]));
      })
      .catch((error: any) => {
        alertError500(error);
        dispatch(servicesSlice.actions.setIsLoading(false));
      });
  };

  // First fetch
  useEffect(() => {
    if (!state.isFetching) fetchData(1,8,'',35,'ASC');
  }, []);

  useEffect(() => {
    if (!state.isFetching) {
      if (
        state.services &&
        state.services[state.page] &&
        state.services[state.page].length > 0 &&
        !state.showService
        && !state.service
      ) {
        dispatch(
          servicesSlice.actions.setService({
            service: state.services[state.page][0] as any,
          }),
        );
        dispatch(servicesSlice.actions.setShowService(true));
        //fetchMaterials(state.services[state.page][0].id)
        showService(state.services[state.page][0].id);
      }
    }
  }, [state.services]);

  useEffect(() => {
    if (pagesInfo && pagesInfo.page !== state.page) {
      if (!state.isFetching) {
        servicesSlice.actions.setPage(pagesInfo.page);
        fetchData(pagesInfo.page);
      }
    }
  }, [pagesInfo]);

  const actions = (service: service) => (
    <div className="show-on-hover">
      {havePermission('Show Glass Work') ? (
        <Tooltip title={t('info')}>
          <i
            className="icon-info"
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              e.stopPropagation();
              showService(service.id);
              setOpenDetailDrawer(true);
              // fetchMaterials(service.id);
              // dispatch(
              //   servicesSlice.actions.setService({
              //     service: service,
              //   }),
              // );

              // dispatch(servicePricingSlice.actions.setService(service));
            }}
          />
        </Tooltip>
      ) : (
        ''
      )}
      {havePermission('Edit Glass Work') ? (
        <Tooltip title={t('edit')}>
          <i
            className="icon-edit"
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              e.stopPropagation();
              setModal((pre) => ({
                ...pre,
                openAddModal: true,
              }));
              dispatch(addServiceSlice.actions.setIsOpen(true));
              dispatch(addServiceSlice.actions.setEditId(service.id));
              dispatch(
                addServiceSlice.actions.set({
                  description: service.description,
                  name: service.name,
                  code: service.code,
                  min_area: service.min_area,
                  unit: service.unit,
                }),
              );
            }}
          />
        </Tooltip>
      ) : (
        ''
      )}
      {havePermission('Delete Glass Work') ? (
        <Tooltip title={t('delete')}>
          <i
            className="icon-delete"
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              e.stopPropagation();
              setOpenDeleteModal(
                (pre: iDeleteModal): iDeleteModal => ({
                  ...pre,
                  open: true,
                  message: t('delete_confirmation'),
                  remove: () => remove(service.id),
                }),
              );
              // Confirm({
              //   message: t('delete_confirmation'),
              //   onConfirm: () => remove(service.id),
              // });
            }}
          />
        </Tooltip>
      ) : (
        ''
      )}
    </div>
  );

  const rows = () => {
    return state.services[state.page]
      ? state.services[state.page].map((service: any, tr_index) => {
          return (
            <RowContainer
              item_id={service.id}
              state_length={state.services[state.page].length}
              tr_index={tr_index}
              onSelect={toggleSelectedId}
              key={service.id}
              columns={[service.code, service.name, actions(service)]}
            />
          );
        })
      : null;
  };

//console.log('state',state)
  return (
    <>
      {state.isLoaded ? (
        <>
          {state.isLoading && !openDetailDrawer ? <WhiteboxLoader /> : ''}
          <Row>
            <Col
              md={
                state.service && havePermission('Show Glass Work')
                  ? isPc
                    ? 6
                    : 12
                  : 12
              }
              style={{ maxHeight: 'calc(100vh - 130px)', overflow: 'auto' }}>
              <TableActionBar
                title={t('services')}
                search={search}
                showFilter={false}
                showDelete={selectedIds.length > 0}
                delete={() => {
                  setOpenDeleteModal(
                    (pre: iDeleteModal): iDeleteModal => ({
                      ...pre,
                      open: true,
                      message: t('delete_confirmation'),
                      remove: () => remove(),
                    }),
                  );
                  // Confirm({
                  //   message: t('delete_confirmation'),
                  //   onConfirm: () => remove(),
                  // });
                }}
                addText={t('add_to_services')}
                add={
                  havePermission('Add Glass Work')
                    ? () => {
                        setModal((pre) => ({ ...pre, openAddModal: true }));
                        dispatch(addServiceSlice.actions.setIsOpen(true));
                      }
                    : undefined
                }
              />

              <SortTable
                header={[t('serial_number'), t('name'), '']}
                onSelect={toggleSelectedId}
                hasMore={state.hasMore}
                loadMore={() => {}}
                pagesInfo={pagesInfo}
                setPagesInfo={setPagesInfo}
                sort_fields={getListSort(['code', 'name', ''], 'Services')}
                fetchSortedData={fetchSortedData}
                header_cell_width={['25%', '50%', '25%']}
                state={state.services[state.page] ?? []}>
                <>{rows()}</>
              </SortTable>
            </Col>
            {state.service &&
              havePermission('Show Glass Work') &&
              (isPc ? (
                <ServiceDetails
                  ENDPOINTS={ENDPOINTS}
                  columnWidth={6}
                  deleteGlassWork={deleteGlassWork}
                  dispatch={dispatch}
                  editGlassWork={editGlassWork}
                  fetchData={fetchData}
                  remove={remove}
                  setModal={setModal}
                  state={state}
                  t={t}
                />
              ) : (
                <DetailDrawer
                  openDetailDrawer={openDetailDrawer}
                  setOpenDetailDrawer={setOpenDetailDrawer}>
                  <>
                  {state.isLoading && openDetailDrawer ? <WhiteboxLoader /> : ''}
                    <ServiceDetails
                      ENDPOINTS={ENDPOINTS}
                      columnWidth={12}
                      deleteGlassWork={deleteGlassWork}
                      dispatch={dispatch}
                      editGlassWork={editGlassWork}
                      fetchData={fetchData}
                      remove={remove}
                      setModal={setModal}
                      state={state}
                      t={t}
                    />

                    <>
                      {modal.openAddModal && (
                        <AddModal
                          close={() =>
                            setModal((pre) => ({ ...pre, openAddModal: false }))
                          }
                        />
                      )}

                      {modal.openShowService && (
                        <Showservice
                          close={() =>
                            setModal((pre) => ({
                              ...pre,
                              openShowService: false,
                            }))
                          }
                        />
                      )}

                      {modal.openServicePricing && (
                        <ServicePricing
                          close={() =>
                            setModal((pre) => ({
                              ...pre,
                              openServicePricing: false,
                            }))
                          }
                        />
                      )}

                      {modal.openEditServicePricing && (
                        <EditServciePricing
                          close={() =>
                            setModal((pre) => ({
                              ...pre,
                              openEditServicePricing: false,
                            }))
                          }
                        />
                      )}
                    </>
                  </>
                </DetailDrawer>
              ))}
          </Row>
          {(isPc || !openDetailDrawer )&& (
            <>
              {modal.openAddModal && (
                <AddModal
                  close={() =>
                    setModal((pre) => ({ ...pre, openAddModal: false }))
                  }
                />
              )}

              {modal.openShowService && (
                <Showservice
                  close={() =>
                    setModal((pre) => ({ ...pre, openShowService: false }))
                  }
                />
              )}

              {modal.openServicePricing && (
                <ServicePricing
                  close={() =>
                    setModal((pre) => ({ ...pre, openServicePricing: false }))
                  }
                />
              )}

              {modal.openEditServicePricing && (
                <EditServciePricing
                  close={() =>
                    setModal((pre) => ({
                      ...pre,
                      openEditServicePricing: false,
                    }))
                  }
                />
              )}
            </>
          )}
        </>
      ) : (
        <div className="center">
          <EllipsisLoader />
        </div>
      )}
    </>
  );
};
export default Services ;
